import React, { MouseEvent } from 'react';

import CustomText from '../../Typography/CustomText/CustomText';
import Box from '../../Box/Box';
import Button from '../../Button/Button';
import Fade from '../../Fade/Fade';
import Row from '../../Grid/Row/Row';
import Column from '../../Grid/Column/Column';
import VStack from '../../VStack/VStack';

import ModalDetailSidebarItem, { SidebarItem } from '../ModalDetailSidebarItem/ModalDetailSidebarItem';
import { DetailSidebarWrapper, DetailSidebarDescription, DetailSidebarList } from '../styles';

export interface ModalDetailSidebarProps {
  tag?: string;
  title?: string;
  actionText?: string;
  sidebarItems: SidebarItem[];
  isActive?: (index: number) => boolean;
  onClick?: (item: SidebarItem, index: number, event: MouseEvent) => void;
  actionCallback?: (event: MouseEvent<HTMLButtonElement>) => void;
  /** @ignore */
  hideModal?: () => void;
  'data-testid'?: string | undefined;
}

function ModalDetailSidebar(props: ModalDetailSidebarProps) {
  const {
    tag,
    title,
    actionText,
    sidebarItems,
    isActive,
    onClick,
    actionCallback,
    'data-testid': dataTestId,
    ...otherProps
  } = props;

  function createSidebarList() {
    return sidebarItems.map((item, index) => (
      <ModalDetailSidebarItem
        key={index}
        label={item.label}
        onClick={e => onClick && onClick(item, index, e)}
        isActive={isActive && isActive(index)}
        {...otherProps}
      />
    ));
  }

  return (
    <DetailSidebarWrapper data-testid={dataTestId} {...otherProps}>
      <DetailSidebarDescription>
        <Row>
          {Boolean(title) && (
            <Column mobile="hidden" tabletPortrait="12-of-12">
              <CustomText color="white" size="xsmall">
                {tag}
              </CustomText>
              <Box bottom="medium">
                <CustomText color="white" size="20" weight="regular">
                  {title}
                </CustomText>
              </Box>
            </Column>
          )}

          <Column mobile="11-of-12" tabletPortrait="hidden">
            <VStack align="left">
              {Boolean(title) && (
                <>
                  <CustomText color="white" size="20" weight="regular">
                    {title}
                  </CustomText>

                  <CustomText color="white" size="xsmall">
                    {tag}
                  </CustomText>
                </>
              )}
              {Boolean(actionText && actionCallback) && (
                <Button
                  id="mobile-sidebar-button"
                  size="auto"
                  onClick={actionCallback}
                  data-testid="modaldetail-sidebar-action"
                >
                  {actionText}
                </Button>
              )}
            </VStack>
          </Column>

          {/*
          <Column mobile="1-of-12" tabletPortrait="hidden">
            <DetailSidebarClose>
              <Button onClick={props.hideModal} type="aura" size="full">
                <Icon type="close" size="xxl" placement="lowest" meaning="close modal" />
              </Button>
            </DetailSidebarClose>
          </Column> */}
        </Row>
      </DetailSidebarDescription>

      <Row>
        <Column mobile="12-of-12">
          <Fade isInverse>
            <DetailSidebarList>{createSidebarList()}</DetailSidebarList>
          </Fade>
        </Column>
      </Row>

      {Boolean(actionText && actionCallback) && (
        <Row>
          <Column mobile="hidden" tabletPortrait="12-of-12">
            <Box horizontal="gutter">
              <Button
                id="desktop-sidebar-button"
                size="small"
                onClick={actionCallback}
                data-testid="modaldetail-sidebar-action"
              >
                {actionText}
              </Button>
            </Box>
          </Column>
        </Row>
      )}
    </DetailSidebarWrapper>
  );
}

ModalDetailSidebar.defaultProps = {
  tag: undefined,
  title: undefined,
  actionText: undefined,
  isActive: (_index: number) => false,
  onClick: (_item: SidebarItem, _index: number, _event: MouseEvent) => {},
  actionCallback: (_event: MouseEvent) => {},
};

export default ModalDetailSidebar;
